import { Body, Checkbox } from '@assembly-js/design-system';
import { ClickAwayListener } from '@mui/material';
import { useState } from 'react';

const NO_BREAK_SPACE = '\u00a0';

interface Props {
  checked: boolean;
  onSaveValue: (checked: boolean) => void;
}

/** Reads as Yes or No; a click swaps in the checkbox, which toggles in place until a click outside. */
export const CheckboxInput = ({ checked, onSaveValue }: Props) => {
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      // Closes on a click outside rather than on blur: the record page moves
      // focus on its own (realtime updates, menus), which would shut it mid-edit.
      <ClickAwayListener onClickAway={() => setEditing(false)}>
        <div className="flex w-full min-h-8 items-center">
          {/* The row aligns its field icon on the value's text baseline; the box
              has none, so this empty strut keeps the icon from dropping on swap. */}
          <Body size="sm" tag="span" className="w-0 overflow-hidden">
            {NO_BREAK_SPACE}
          </Body>
          <Checkbox
            label=""
            checked={checked}
            autoFocus
            onChange={(e) => onSaveValue(e.target.checked)}
            onKeyDown={(e) => {
              if (e.key === 'Escape') setEditing(false);
            }}
          />
        </div>
      </ClickAwayListener>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setEditing(true)}
      className="flex w-full min-h-8 cursor-pointer appearance-none items-center border-0 bg-transparent px-0 text-left"
    >
      <Body size="sm">{checked ? 'Yes' : 'No'}</Body>
    </button>
  );
};
